const getCountryDetails = (apiData, country) => {
  return apiData?.Countries?.find((c) => c.Country === country)
}

export default getCountryDetails
